import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Products from './Products'

/**
 * FilterDataDisplay - Page Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class FilterDataDisplay extends Component {
  /**
   * Default props
   *
   * @type {{list: Array}}
   */
  static defaultProps = {
    cream: [],
    organic: [],
    natural: [],
    pops: []
  }

  /**
   * Prop Types
   *
   * @type {{}}
   */
  static propTypes = {
    openModalPopup: PropTypes.func
  }

  /**
   *
   * @type {{value: string}}
   */
  state = {
    cream: [],
    organic: [],
    natural: [],
    pops: [],
    value: ''
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    const { list } = this.props

    this.setState({
      list: list
    })
  }

  /**
   * Component will receive props
   *
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    this.setState({
      list: nextProps.list
    })
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { cream, organic, natural, pops, openModalPopup } = this.props

    return (
      <div className="FilterDataDisplay">
        <div>
          <ul>
            <Products products={cream} openModalPopup={openModalPopup} type="cream" />
          </ul>
          <ul>
            <Products products={organic} openModalPopup={openModalPopup} type="organic" />
          </ul>
          <ul>
            <Products products={natural} openModalPopup={openModalPopup} type="natural" />
          </ul>
          <ul>
            <Products products={pops} openModalPopup={openModalPopup} type="pops" />
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/filterProducts/FilterDataDisplay.jsx